/**
 * @architecture-header 1
 * @layer shared
 * @domain workspace-state
 * @responsibility Coordinate reset-only callbacks for context-scoped transient UI stores.
 * @state-owner module-scoped reset callback registry
 * @allowed-imports TypeScript standard library
 * @forbidden API entities; roles; permissions; tokens; React; localStorage
 * @public-api auth context teardown and module UI stores
 * @side-effects invokes registered in-memory reset callbacks
 * @tests module-contracts.test.ts
 */

export interface WorkspaceTransientResetOptions {
  /** Sign-out only: also reset the interface-language preference to its default. */
  readonly resetLanguage?: boolean;
}

type TransientReset = (options?: WorkspaceTransientResetOptions) => void;

const transientResets = new Map<string, TransientReset>();

export function registerWorkspaceTransientReset(key: string, reset: TransientReset) {
  transientResets.set(key, reset);
}

export function resetWorkspaceTransientState(options?: WorkspaceTransientResetOptions) {
  for (const reset of transientResets.values()) reset(options);
}
